import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Description',
    field: 'description',
    // displayValue: row => {
    //   // return `${row.line1} ${row.city}, ` + row.state && row.state.code ? row.state.code : ''
    //   // return `${row.line1}, ${row.city}, `
    //   return [row.line1, row.suiteNumber, row.city, row.state && row.state.code ? row.state.code : row.state, row.zipCode].filter(v => !!v).join(', ')
    // },
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Street Address 1',
    field: 'line1',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'City, State, Zip',
    field: 'cityStateZip',
    visible: false,
    displayValue: row => {
      return `${row.city}, ${row.state.code} ${row.zipCode}`
      // return [row.line1, row.suiteNumber, row.city, row.state && row.state.code ? row.state.code : row.state, row.zipCode].filter(v => !!v).join(', ')
    },
    component: null
  }),
  createColumn({
    label: 'Suite #',
    field: 'suiteNumber',
    component: inputTextField({ req: false })
  }),
  // createColumn({
  //   label: 'Street Address 2',
  //   field: 'line2',
  //   component: inputTextField({ req: false })
  // }),
  // createColumn({
  //   label: 'Street Address 3',
  //   field: 'line3',
  //   component: inputTextField({ req: false })
  // }),
  createColumn({
    label: 'City',
    field: 'city',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'State',
    field: 'state',
    // displayValue: row => `${row.state.name}`.trim(),
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'stateId',
      fk: 'id',
      namespace: 'state',
      searchColumns: ['code', 'name'],
      label: 'code',
      props: {
        addButton: false,
        allowEdit: false
      }
    })
  }),
  createColumn({
    label: 'Zip/Postal Code',
    field: 'zipCode',
    component: inputTextField({ req: true, type: 'text' })
  }),
  createColumn({
    label: 'Country',
    field: 'country',
    // description: 'Listing of all users who have access to modify this school'
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'countryId',
      fk: 'id',
      namespace: 'country',
      label: 'name',
      props: {
        addButton: false,
        allowEdit: false
      }
    })
  }),
  // createColumn({
  //   label: 'Districts',
  //   field: 'districts',
  //   visible: false,
  //   displayValue: row => {
  //     return `Districts - Federal: ${row.federalHouseDistrict}, State: ${row.stateHouseDistrict}, Senate: ${row.stateSenateDistrict} `
  //     // return [row.line1, row.suiteNumber, row.city, row.state && row.state.code ? row.state.code : row.state, row.zipCode].filter(v => !!v).join(', ')
  //   },
  //   component: null
  // }),
  createColumn({
    label: 'State House District',
    field: 'stateHouseDistrict',
    section: 'Governemnt Districts',
    component: inputTextField({ req: false })
  }),
  createColumn({
    label: 'State Senate District',
    field: 'stateSenateDistrict',
    section: 'Governemnt Districts',
    component: inputTextField({ req: false })
  }),
  createColumn({
    label: 'Federal House District',
    field: 'federalHouseDistrict',
    section: 'Governemnt Districts',
    component: inputTextField({ req: false })
  }),
  createColumn({
    label: 'Validated',
    field: 'beenValidated',
    section: 'Status',
    // description: 'School is allowed to order on weekends',
    type: 'boolean',
    visible: false,
    component: null
    // component: booleanComponent
  }),
  createColumn({
    label: 'GUID',
    field: 'guidId',
    type: 'text',
    section: 'Data Info',
    filterable: false,
    visible: false,
    searchable: false,
    // defaultValue: guid,
    component: null
    // component: {
    //   req: true,
    //   props: {
    //     type: 'text',
    //     disable: true
    //   }
    // }
  }),
  createColumn({
    label: 'Approved',
    field: 'approved',
    section: 'Status',
    // description: 'School is allowed to order on weekends',
    type: 'boolean',
    visible: false,
    defaultValue: true,
    component: null
    // component: booleanComponent
  }),
  createColumn({
    label: 'Date Approved',
    field: 'dateApproved',
    type: 'datetime',
    section: 'Status',
    visible: false,
    component: null
    // component: {
    //   is: 'q-datetime',
    //   props: {
    //     type: 'datetime'
    //     // disable: true
    //   }
    // }
  })
].concat(defaultColumns)
